import { useHomeContextUser } from "../homeContext";
import { useCurrentVstLocale } from "../../../common/utils/locale";
import useJigsawUser from "../common/user/useJigsawUser";
import styles from "./Groups.module.scss";
import PageTitle from "../common/page-title/PageTitle";
import { useIntl } from "react-intl";
import { useRouteMainFocus } from "../layout/content-templates/utils/useRouteMainFocus.ts";
import useAccessiblePageTitle from "../common/page-title/useAccessiblePageTitle.tsx";
import BaseHeader from "../common/header/BaseHeader.tsx";

export default function GroupsComponent() {
  const user = useHomeContextUser();
  const jigsawUser = useJigsawUser();
  const vstLocale = useCurrentVstLocale();
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Groups" });
  const accessiblePageTitle = useAccessiblePageTitle(title);
  useRouteMainFocus();

  if (jigsawUser) {
    return (
      <main aria-label={accessiblePageTitle} className={styles.main}>
        <PageTitle title={title} noHeading />
        <BaseHeader />
        <rostering-groups
          isnative={false}
          jigsawsessionid={jigsawUser.user.sessionId}
          lang={vstLocale}
          hasadmin={user.hasAdmin}
          hasgroups={user.hasGroups}
          omitbasename={true}
        />
      </main>
    );
  }
}
